import React from 'react';
import './DetailsReviewComp.css';
import {Grid} from '@mui/material'
import { FaFilter } from 'react-icons/fa';

const DetailsReviewComp = () => {

    return (
    <div className='ReviewCompMain'>
      <hr style={{marginTop:'7vh',borderColor:'#f2f2f2'}} />
      <p style={{fontWeight:700,fontSize:20}}>No reviews (yet)</p>
      <Grid container>
        <Grid item md={6}>
            <div className='reviewCompSub'>
            <div style={{width:'10%'}}>
                <FaFilter  style={{height:18,width:18}} />
            </div>
            <div style={{width:'90%'}}>
                 <span style={{marginLeft:0}}>This host has 764 reviews for other places to stay.<span className='detailsReviewSubBold'>Show other reviews</span></span>
                 </div>
            </div>
        </Grid>
        <Grid item md={6}>
        <div className='reviewCompSub'>
            <div style={{width:'10%'}}>
                <FaFilter  style={{height:18,width:18}} />
            </div>
            <div style={{width:'90%'}}>
                 <span style={{marginLeft:0}}>We're here to help your trip go smoothly. Every reservation is covered by <span className='detailsReviewSubBold'>Airbnb's Guest Refund Policy</span></span>            
            </div>
            </div>
        </Grid>
      </Grid>
      <hr style={{marginTop:'7vh',borderColor:'#f2f2f2'}} />
    </div>
  )
}

export default DetailsReviewComp